export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/badge_background-b5801acf19ae01d5ad5faeda808409a6.svg";